<div class="pss-toast-stack" aria-live="polite" aria-relevant="additions">
  <div
    *ngFor="let t of toasts(); trackBy: trackById"
    class="pss-toast"
    [class.pss-toast--leaving]="t.leaving"
    [attr.data-kind]="t.kind"
    role="status">
    <div class="pss-toast__accent"></div>

    <div class="pss-toast__icon" aria-hidden="true">
      <span class="material-icons">{{ iconFor(t.kind) }}</span>
    </div>

    <div class="pss-toast__body">
      <p class="pss-toast__label">{{ labelFor(t.kind) }}</p>
      <p class="pss-toast__message">{{ t.message }}</p>
    </div>

    <button type="button" class="pss-toast__close" (click)="dismiss(t.id)" aria-label="ปิด">
      <span class="material-icons">close</span>
    </button>

    <div class="pss-toast__progress" [style.animation-duration.ms]="t.durationMs"></div>
  </div>
</div>
